var toString = require('../lang/toString');
    /**
     * "Safer" String.toLowerCase()
     */
    function lowerCase(str){
        str = toString(str);
        return str.toLowerCase();
    }

    module.exports = lowerCase;




//////////////////
// WEBPACK FOOTER
// ./~/mout/string/lowerCase.js
// module id = 276
// module chunks = 0 1 2